module.exports = __webpack_public_path__ + "static/media/login.d1adabbe.svg";